import { call, put, putResolve, select } from "redux-saga/effects";
import { actions } from "../actions";
import { IFinalizePackage } from "../actions/actions";
import Logger from "../../../utils/logger";
import {
  FinalizePackageResponse,
  PackagedRoom,
  Platform,
  SafePackageDetails,
} from "redmond";
import { selectedPackageByRateId } from "../../hotel-shop/reducer";
import { IStoreState } from "../../../reducers/types";
import { getSelectedReturnFlightPackage } from "../../flight-shop/reducer";
import { getPackageSearchKey } from "../../package-identity/reducer/selectors";
import { finalizeFlightLodging } from "../../../api/v0/itinerary-review/finalizeFlightLodging";
import { pollPackageVersion } from "../utils/pollPackageVersion";
import { setDateRange } from "../../hotel-shop/actions/actions";

export default function* finalizePackageSaga(action: IFinalizePackage) {
  try {
    const state: IStoreState = yield select();
    let selectedPackage: PackagedRoom | undefined =
      yield selectedPackageByRateId(state);
    let selectedFlightPackage: SafePackageDetails | undefined =
      yield getSelectedReturnFlightPackage(state);
    const lodgingQuoteRequest = selectedPackage?.opaqueQuoteRequest;
    const flightPackageToken = selectedFlightPackage?.opaquePackageToken;

    if (!lodgingQuoteRequest || !flightPackageToken) {
      throw new Error("Hotel and flight tokens must be present.");
    }

    const searchKey = getPackageSearchKey(state);
    if (searchKey != null && action.versionPollTarget != null) {
      yield call(pollPackageVersion, {
        searchKey,
        targetVersion: action.versionPollTarget,
      });
    }

    const response: FinalizePackageResponse = yield finalizeFlightLodging({
      opaqueQuoteRequest: lodgingQuoteRequest,
      opaquePackageToken: flightPackageToken,
      platform: Platform.Desktop,
    });

    if (
      !!response?.lodgingStayDates?.from &&
      !!response?.lodgingStayDates?.until
    ) {
      yield putResolve(setDateRange(response.lodgingStayDates));
    }

    yield putResolve(actions.setFinalizePackageResponse(response));
  } catch (e) {
    Logger.debug(e);
    yield put(actions.setFinalizePackageResponseCallStateFailed(e));
  }
}
